import React from "react";
import { Modal } from "antd";
import { toast } from "react-toastify";
import {
  DeleteOutline,
  EditOutlined,
  PauseCircleOutline,
  PlayCircleOutline,
} from "@mui/icons-material";

import { formatDate, getFullName, getInitials } from "../adminUtils";

const resolveValue = (val) => {
  if (val == null) return null;
  if (typeof val === "object") return val?.title || val?.name || val?.value || "";
  return val;
};

const RecordRow = ({
  record,
  type,
  onEdit,
  onDelete,
  isSelf,
  onViewDetail,
  onSetPaused,
}) => {
  const id = record.id || record._id;
  const subText = [record.username, record.phone]
    .map((val) => (typeof val === "string" ? val.trim() : val))
    .find((val) => val && val !== "-");
  console.log(record, 'record')
  const handleDelete = () => {
    if (!id) {
      toast.error("Record id is missing.", {
        position: "top-center",
        containerId: "main",
        theme: "light",
      });
      return;
    }

    Modal.confirm({
      title: `Delete ${getFullName(record)}?`,
      content: "This action cannot be undone.",
      okText: "Delete",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: () => onDelete(id),
    });
  };

  const isPaused = !!record.isPaused;

  const handleTogglePause = () => {
    if (!id) {
      toast.error("Record id is missing.", {
        position: "top-center",
        containerId: "main",
        theme: "light",
      });
      return;
    }

    Modal.confirm({
      title: `${isPaused ? "Resume" : "Pause"} ${getFullName(record)}?`,
      content: isPaused
        ? "They will appear in the member list again and can receive new service requests."
        : "They will be hidden from the member list and stop receiving new service requests. They can resume their account themselves from their profile at any time.",
      okText: isPaused ? "Resume" : "Pause",
      okButtonProps: { danger: !isPaused },
      cancelText: "Cancel",
      onOk: () => onSetPaused(id, !isPaused),
    });
  };

  return (
    <tr>
      <td>
        <div
          className="admin-person"
          onClick={type === "users" && onViewDetail ? () => onViewDetail(record) : undefined}
          style={type === "users" && onViewDetail ? { cursor: "pointer" } : undefined}
          title={type === "users" ? "View details" : undefined}
        >
          <span className="admin-avatar">{getInitials(record)}</span>
          <div>
            <strong style={type === "users" && onViewDetail ? { color: "#1cc400" } : undefined}>
              {getFullName(record)}
              {type === "users" && isPaused && (
                <span
                  style={{
                    marginLeft: 8,
                    padding: "1px 8px",
                    borderRadius: 9999,
                    background: "#fef3c7",
                    color: "#92400e",
                    fontSize: 11,
                    fontWeight: 600,
                    verticalAlign: "middle",
                  }}
                >
                  Paused
                </span>
              )}
            </strong>
            {subText && <span>{subText}</span>}
          </div>
        </div>
      </td>
      <td>{record.email || "-"}</td>
      <td>
        {type === "users" ? (
          resolveValue(record.balance) ?? 0
        ) : (
          <span className="admin-muted">{resolveValue(record.role) || "admin"}</span>
        )}
      </td>
      <td>{formatDate(record.createdAt)}</td>
      <td>
        <div className="admin-row-actions">
          <button
            aria-label="Edit"
            className="admin-icon-btn"
            disabled={isSelf}
            onClick={() => !isSelf && onEdit(record)}
            title={isSelf ? "Cannot edit your own account" : "Edit"}
            type="button"
          >
            <EditOutlined fontSize="small" />
          </button>
          {type === "users" && onSetPaused && (
            <button
              aria-label={isPaused ? "Resume account" : "Pause account"}
              className="admin-icon-btn"
              onClick={handleTogglePause}
              title={isPaused ? "Resume account" : "Pause account"}
              type="button"
            >
              {isPaused ? (
                <PlayCircleOutline fontSize="small" />
              ) : (
                <PauseCircleOutline fontSize="small" />
              )}
            </button>
          )}
          <button
            aria-label="Delete"
            className="admin-icon-btn admin-icon-btn-danger"
            disabled={isSelf}
            onClick={!isSelf ? handleDelete : undefined}
            title={isSelf ? "Cannot delete your own account" : "Delete"}
            type="button"
          >
            <DeleteOutline fontSize="small" />
          </button>
          {isSelf && <span className="admin-self-badge">You</span>}
        </div>
      </td>
    </tr>
  );
};

export default RecordRow;
